<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col md="6">
                <joborder-edit-form
                    title="Create new job order"
                    v-bind:order="order"
                    v-on:submit="submit"
                    v-on:cancel="$router.go(-1)"
                />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import orderApi from '@/api/orderApi';
import snackbar from '@/utils/snackbar';

export default {
    components: {
        'joborder-edit-form': () => import('@/views/op/JobOrderEditForm.vue')
    },
    data() {
        return {
            order: {
                customer_name: null,
                customer_phone: null,
                payment_type: null,
                service_charge: null,
                operator_notes: null,
                orderable: {
                    description: null
                }
            }
        };
    },
    methods: {
        async submit() {
            const response = await orderApi.createJobOrder(this.order);
            this.$router.push({
                name: 'op-joborder-show',
                params: { order_id: response.data.order.id }
            });
            snackbar.show('Order created', 'success');
        }
    }
};
</script>
